<div 
    *ngIf="caseId && stage" class="z-30 fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75"
    (click)="$event.preventDefault(); handleCloseTeam();"
>
    <div class="max-h-screen w-full flex flex-col items-center justify-center overflow-hidden">
        <div class="w-full max-w-screen-sm flex my-6 p-8 gap-8 bg-white rounded-md shadow-lg overflow-hidden" (click)="$event.stopPropagation()">
            <div class="w-full flex flex-col overflow-hidden">
                <h2 class="w-full oswald-font text-xl font-medium text-start text-nside-orange-400">
                    Review is pending for case {{ caseId }}
                </h2>
                <p class="w-full text-start pb-4">
                    Review request needs to be cancelled before making changes.
                </p>
                <div class="w-full my-2 flex items-end justify-between oswald-font">
                    <div class="h-full w-full flex items-end justify-end gap-2">
                        <button
                            class="py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                            (click)="$event.preventDefault(); handleCloseTeam();"
                        >
                            Close
                        </button>
                        <button 
                            class="px-2.5 h-full flex items-center justify-center rounded-md border bg-gradient-to-b oswald-font text-white border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200"
                            (click)="$event.preventDefault(); handleSendRequest();"
                        >
                            Cancel Review Request
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>
